import ClickCease from './ClickCease.client';
import GoogleReviewBadge from './GoogleReviewBadge.client';
import MsClarity from './MsClarity.client';
import WisePops from './WisePops.client';
import WisePopsNotifications from './WisePopsNotifications.client';

export default function ExtraScripts() {
  return (
    <>
      <GoogleReviewBadge />
      <ClickCease />
      <WisePops />
      <WisePopsNotifications />
      <MsClarity />
    </>
  );
}
